import playback from './playback';
import controls from './controls';

export default {
  playback,
  controls,
};
